(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after-lift"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = () => document.querySelectorAll('.before-after-lift');
    const desktopQuery = window.matchMedia('(min-width: 990px)');
    let frameId = null;

    const syncSectionHeight = (section) => {
      const mediaCard = section.querySelector('.before-after-lift__media-card');
      const contentCard = section.querySelector('.before-after-lift__content-card');
      const image = section.querySelector('.before-after-lift__image');

      section.classList.remove('before-after-lift--compact', 'before-after-lift--content-overflow');

      if (!mediaCard || !contentCard || !image || !desktopQuery.matches) {
        section.style.removeProperty('--bal-synced-media-height');
        return;
      }

      section.style.removeProperty('--bal-synced-media-height');

      requestAnimationFrame(() => {
        const mediaHeight = Math.round(mediaCard.getBoundingClientRect().height);

        if (mediaHeight > 0) {
          section.style.setProperty('--bal-synced-media-height', `${mediaHeight}px`);
        }

        requestAnimationFrame(() => {
          if (contentCard.scrollHeight > contentCard.clientHeight + 1) {
            section.classList.add('before-after-lift--compact');

            requestAnimationFrame(() => {
              if (contentCard.scrollHeight > contentCard.clientHeight + 1) {
                section.classList.add('before-after-lift--content-overflow');
              }
            });
          }
        });
      });
    };

    const bindImageLoad = (section) => {
      if (section.dataset.beforeAfterLiftBound === 'true') return;

      const image = section.querySelector('.before-after-lift__image');
      section.dataset.beforeAfterLiftBound = 'true';

      if (image) {
        image.addEventListener('load', scheduleSync, { passive: true });
      }
    };

    const syncAll = () => {
      sections().forEach((section) => {
        bindImageLoad(section);
        syncSectionHeight(section);
      });
    };

    function scheduleSync() {
      if (frameId) cancelAnimationFrame(frameId);
      frameId = requestAnimationFrame(syncAll);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scheduleSync);
    } else {
      scheduleSync();
    }

    window.addEventListener('load', scheduleSync);
    window.addEventListener('resize', scheduleSync);
    document.addEventListener('shopify:section:load', scheduleSync);
    document.addEventListener('shopify:section:select', scheduleSync);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["puff-best-sellers"] && !Shopify.designMode) return;
  try {
    
  if (!window.puffBestSellersCardLinkInit) {
    window.puffBestSellersCardLinkInit = true;

    document.addEventListener('click', function(event) {
      var card = event.target.closest('.puff-best-sellers__card[data-card-url]');

      if (!card || event.target.closest('a, button, input, select, textarea, form, label')) {
        return;
      }

      var url = card.getAttribute('data-card-url');

      if (url) {
        window.location.href = url;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
